export default `
  mutation updateBCObject($workflowId: String!, $id: ID!, $input: UpdateBCObjectInput!) {
    updateBCObject(workflowId: $workflowId, id: $id, input: $input) {
      id
      boundedContextId
      filepath
      prompt
      contents
      draftContents
      tags
    }
  }
`
